import {Form} from "../../helpers/forms/Form";

// noinspection JSUnusedGlobalSymbols -- Imported via d.ts
class UserForm extends Form {
	constructor(config) {
		super({
			// Basic fields that we read directly from the DOM
			fields: [
				'first_name',
				'last_name',
				'email',
				'password',
				'role_id'
			],
			...config
		});

		// Here we initialize any advanced fields or anything that
		// we need to keep in memory
	}
}

export {UserForm}
